"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var test_attributes_1 = require("@carvana/test-attributes");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var Checkbox_styles_1 = require("./Checkbox.styles");
var Checkbox = (0, react_1.forwardRef)(function (_a, ref) {
    var id = _a.id, _b = _a.value, value = _b === void 0 ? '' : _b, name = _a.name, label = _a.label, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.indeterminate, indeterminate = _d === void 0 ? false : _d, disabled = _a.disabled, className = _a.className, _e = _a.variant, variant = _e === void 0 ? 'primary' : _e, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, _f = _a.testId, testId = _f === void 0 ? 'Checkbox' : _f, props = __rest(_a, ["id", "value", "name", "label", "checked", "indeterminate", "disabled", "className", "variant", "onBlur", "onChange", "onFocus", "testId"]);
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var internalRef = (0, react_1.useRef)(null);
    var handleBlur = function (e) {
        if (onBlur)
            onBlur(e);
    };
    var handleChange = function (e) {
        if (onChange)
            onChange(e);
    };
    var handleFocus = function (e) {
        if (onFocus)
            onFocus(e);
    };
    (0, react_1.useEffect)(function () {
        if (internalRef.current) {
            internalRef.current.indeterminate = indeterminate;
        }
    }, [internalRef, indeterminate]);
    var synchronizeRefs = function (element) {
        internalRef.current = element;
        if (!ref)
            return;
        if (typeof ref === 'function') {
            ref(element);
        }
        else {
            ref.current = element;
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Checkbox_styles_1.CheckboxWrapper, __assign({ className: (0, classnames_1.default)(variant === "inverse" ? "checkbox--inverse" : "checkbox--primary", (checked || indeterminate) && "checkbox--checked", disabled && "checkbox--disabled", className), "data-testid": testId }, { children: [(0, jsx_runtime_1.jsx)(Checkbox_styles_1.HiddenNativeCheckbox, __assign({ ref: synchronizeRefs, id: id, value: value, name: name, type: "checkbox", role: "checkbox", "aria-checked": indeterminate ? "mixed" : checked, checked: checked, disabled: disabled, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus }, props, getTestAttributes("checkbox"))), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "checkbox--frame" }, { children: [checked && (0, jsx_runtime_1.jsx)(helios_icons_1.Check, { color: disabled ? Checkbox_styles_1.icon.disabled : Checkbox_styles_1.icon.inverse }), indeterminate && (0, jsx_runtime_1.jsx)(helios_icons_1.Minus, { color: disabled ? Checkbox_styles_1.icon.disabled : Checkbox_styles_1.icon.inverse })] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "checkbox--label" }, { children: label }))] })));
});
exports.default = Checkbox;
